import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { SERVICES } from './LandingConstants';
import { PrimaryButton } from '../../CommonComponents/Button';
import EnrollForm from '../components/EnrollForm/EnrollForm';
import { subscribersErrorsSelector } from '../ExperianSelector';
import StatusPage from '../components/StatusPage/StatusPage';
import { Card, Heading, Services, StyledService, SubHeading, Wrapper } from './LandingStyles';

const Service = ({ title, icon, children }) => (
  <StyledService>
    <i className={icon} />
    <h3>{title}</h3>
    <p>{children}</p>
  </StyledService>
);

Service.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};

const Landing = () => {
  const [showForm, setShowForm] = useState(false);

  const subscribersErrors = useSelector(subscribersErrorsSelector);

  const enrollCallback = useCallback(() => {
    setShowForm(true);
  }, []);

  return subscribersErrors.length > 0 ? (
    <StatusPage icon="fas fa-exclamation-circle" iconColor="#dd6c64" accentColor="#fde1e6">
      Credit & Identity Monitoring is not available at the moment
    </StatusPage>
  ) : (
    <>
      <Wrapper>
        <Card>
          <Heading>Enroll in Online Identity and Financial Account Monitoring Services</Heading>
          <SubHeading>Description of the services being offered:</SubHeading>
          <Services>
            {SERVICES.map(({ id, title, icon, message }) => (
              <Service key={id} title={title} icon={icon}>
                {message}
              </Service>
            ))}
          </Services>
        </Card>
        <PrimaryButton onClick={enrollCallback}>Enroll</PrimaryButton>
      </Wrapper>
      <EnrollForm isOpen={showForm} onCancel={() => setShowForm(false)} />
    </>
  );
};

export default Landing;
